import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { usePropertyWorkNeeded } from '../../../../../../queries/PropertyFields/BridgeFields';

interface AnyWorkRemainingProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const AnyWorkRemaining: React.FC<AnyWorkRemainingProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Does any work need to be completed on the property?';

    const [workNeeded, set_workNeeded] = usePropertyWorkNeeded(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_workNeeded(true);
                return;
            case 'no':
                set_workNeeded(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={workNeeded ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonAnyWorkRemaining'
                    value={workNeeded}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='This field is required.'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
